import { CommonModule } from '@angular/common';
import { Component, inject, OnInit } from '@angular/core';
import { FirebaseApp } from '@angular/fire/app';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatTabsModule } from '@angular/material/tabs';
import { RouterModule } from '@angular/router';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { AuthService } from '@price-management-console/auth';
import {
  DEFAULT_LANG,
  EN_LANG,
  LANG_KEY,
} from './core/constants/storage.constants';
import { LocalStorageService } from './services/local-storage.service';

@Component({
  imports: [
    RouterModule,
    MatTabsModule,
    MatProgressSpinnerModule,
    CommonModule,
    TranslateModule,
  ],
  selector: 'app-root',
  templateUrl: './app.html',
  styleUrl: './app.scss',
  standalone: true,
})
export class App implements OnInit {
  protected title = 'price-management-console';
  public authService = inject(AuthService);
  private readonly translate = inject(TranslateService);
  private readonly localStorageService = inject(LocalStorageService);

  constructor() {
    const firebaseApp = inject(FirebaseApp);
    console.log('Firebase App Initialized:', firebaseApp);
    console.log('Firebase Project ID:', firebaseApp.options.projectId);
  }

  ngOnInit() {
    this.setLanguage(DEFAULT_LANG);
    this.authService.initialize();
  }

  /**
   * This functions sets the language.
   * Uses provided language, saved local storage value, or defaults to English.
   * Persists selected language in local storage.
   */
  setLanguage(lang?: string): void {
    const selectedLang =
      lang || this.localStorageService.getValue(LANG_KEY) || DEFAULT_LANG;

    this.translate.setFallbackLang(EN_LANG);
    this.translate.use(selectedLang);
    this.localStorageService.setValue(LANG_KEY, selectedLang);
  }
}
